import { fetchBanks } from "./banksAction";
import { refetchCategories } from "./categoriesAction";
import { fetchSuppliers } from "./suppliersAction";
import { fetchUsers } from "./userAction";
import { fetchLabels } from "./labelsAction";
import { fetchUserSpendings, fetchAdminSpendings } from "./spendingAction";

export function refreshAll() {
    return async function(dispatch){
        try{
            dispatch(fetchBanks())
            dispatch(refetchCategories())
            dispatch(fetchSuppliers())
            dispatch(fetchLabels())
            dispatch(fetchUserSpendings())
            dispatch(fetchAdminSpendings())
            dispatch(fetchUsers())

        } catch(err) {
            console.log("[ERROR] refreshAll ", err);
        }
    }
}